import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';

import Avatar from 'react-avatar';

import './index.scss';

const Person = ({ username, subtitleLabel = 'Email', email, removable, onRemove, popup = true, isUsernameOnly = false, unsetFontSize = false , isInactiveUser = false, title, isSystemGenerated = false, avatarSize = '3em', link = null, popupSubTitle }) => {
    const details = (
        <div className='Person'>
            {isSystemGenerated && <Icon
                className='fas fa-robot AutomationIcon'
                circular
                size='large' />}
            {username && !isSystemGenerated && <Avatar name={username} title={title} maxInitials={2} round size={avatarSize} className={`${unsetFontSize ? "Person__avatar--unsetFontSize" : ""} ${isInactiveUser ? "Person__avatar--inactive" : ""}`} />}
            <div className={`Person__information${isUsernameOnly ? ' Person__information--single-line' : ''}`}>
                {username && <div><span className="Person__name"><b>{link || username}</b></span></div>}
                {!isUsernameOnly && <div><span className="Person__email">{email}</span></div>}
            </div>
            {removable && (
                <div className="Person__remove">
                    <Icon
                        name='delete'
                        link
                        onClick={onRemove}
                    />
                </div>
            )}
        </div>
    )
    return (
        popup ? (
            <Popup
                inverted
                content={(
                    <div>
                        <p>Name: {username}</p>
                        {!isUsernameOnly && !popupSubTitle && <p>{subtitleLabel}: {email}</p>}
                        {popupSubTitle && <>{popupSubTitle}</>}
                    </div>
                )}
                trigger={(details)}
            />
        ) : details
    )
};

export default Person;
